module.exports = __webpack_public_path__ + "img/top_left.7e91b50b.png";